import Chart from 'chart.js/auto';

/* eslint-disable no-unused-expressions */
export function getChartApexDefaultOptions() {
	var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
	var bodyColor = (getComputedStyle(document.body).getPropertyValue('--bs-body-color')).trim();
	var bodyFontWeight = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight')).trim();
	var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
	
	return {
		title: {
			style: {
				fontSize: '12px',
				fontWeight: bodyFontWeight,
				fontFamily: bodyFontFamily,
				color: bodyColor
			}
		},
		legend: {
			fontSize: '10px',
			fontFamily: bodyFontFamily,
			labels: { colors: bodyColor }
		},
		tooltip: {
			style: {
				fontSize: '10px',
				fontFamily: bodyFontFamily
			}
		},
		grid: { borderColor: borderColor },
		dataLabels: {
			style: {
				fontSize: '10px',
				fontFamily: bodyFontFamily,
				fontWeight: '500',
				colors: undefined
			}
		},
		xaxis: {
			axisBorder: {
				show: true,
				color: borderColor,
				height: 1,
				width: '100%',
				offsetX: 0,
				offsetY: -1
			},
			axisTicks: {
				show: true,
				borderType: 'solid',
				color: borderColor,
				height: 6,
				offsetX: 0,
				offsetY: 0
			},
			labels: {
				style: {
					colors: bodyColor,
					fontSize: '10px',
					fontFamily: bodyFontFamily,
					fontWeight: bodyFontWeight,
					cssClass: 'apexcharts-xaxis-label',
				}
			}
		},
		yaxis: {
			labels: {
				style: {
					colors: bodyColor,
					fontSize: '10px',
					fontFamily: bodyFontFamily,
					fontWeight: bodyFontWeight,
					cssClass: 'apexcharts-xaxis-label',
				}
			}
		}
	};
};

export function getChartJsDefaultOptions() {
	var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
	var bodyFontWeight = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight')).trim();
	var bodyColor = (getComputedStyle(document.body).getPropertyValue('--bs-body-color')).trim();
	var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
	var black = (getComputedStyle(document.body).getPropertyValue('--bs-black')).trim();
	var blackRgb = (getComputedStyle(document.body).getPropertyValue('--bs-black-rgb')).trim();
	
	Chart.defaults.font.family = bodyFontFamily;
	Chart.defaults.font.size = 10;
	Chart.defaults.font.weight = 500;
	Chart.defaults.color = bodyColor;
	Chart.defaults.borderColor = borderColor;
	Chart.defaults.plugins.legend.display = false;
	Chart.defaults.plugins.tooltip.padding = { left: 8, right: 12, top: 8, bottom: 8 };
	Chart.defaults.plugins.tooltip.cornerRadius = 8;
	Chart.defaults.plugins.tooltip.titleMarginBottom = 6;
	Chart.defaults.plugins.tooltip.color = black;
	Chart.defaults.plugins.tooltip.multiKeyBackground = 'rgba('+ blackRgb +', .95)';
	Chart.defaults.plugins.tooltip.backgroundColor = 'rgba('+ blackRgb +', .95)';
	Chart.defaults.plugins.tooltip.titleFont.family = bodyFontFamily;
	Chart.defaults.plugins.tooltip.titleFont.weight = bodyFontWeight;
	Chart.defaults.plugins.tooltip.footerFont.family =bodyFontFamily;
	Chart.defaults.plugins.tooltip.displayColors = true;
	Chart.defaults.plugins.tooltip.boxPadding = 6;
	Chart.defaults.scale.grid.color = borderColor;
	Chart.defaults.scale.beginAtZero = true;
};
